import styled from 'styled-components';

const InsuranceWraper = styled.div`
#basic,
.p-inputwrapper {
	width: 100%;
}

margin:auto;
padding:60px 0 16px;
background-image: linear-gradient(to bottom, #f9fdff 0%, rgba(249, 253, 255, 0) 100%),
linear-gradient(to bottom, #fff, #fff);

}
.insurance h3 {
	font-size: 24px;
	font-weight: 800;
	line-height: 1.33;
	text-align: initial;
	color: #4c565c;
	width: 60%;
}
.control-label:after {
	content: " *";
	color: red;
}
.box {
	border: 1px solid #6B47F5 !important;
}

 .text-with-line {
    position: relative;
    display: inline-block;
  }

  .text-with-line::before {
    content: "";
    position: absolute;
    bottom: 50%;
    left: 0;
    right: 0;
    border-bottom: 1px solid black; /* You can change the color here */
    z-index: 2;
  }

  .active-text-with-line {
    position: relative;
    display: inline-block;
  }

  .active-text-with-line::before {
    content: "";
    position: absolute;
    bottom: 50%;
    left: 0;
    right: 0;
    border-bottom: 1px solid white; /* You can change the color here */
    z-index: 2;
  }

  .discount_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 5px 0px 5px 0px;
    gap: 5px;

    .number {
      font-family: Tawuniya;
      font-size: 14px;
      font-weight: 400;
      line-height: 14px;
    }

    .active-number {
      color: white;
    }

    .tag_container {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 12px;
      padding: 5px 12px 5px 12px;
      background-color: #f0fff5;

      font-family: Tawuniya;
      font-size: 12px;
      font-weight: 400;
      line-height: 12px;
      color: var(--Success-Success, #5db364);
    }

    .active-tag {
      background-color: #312e52;
      color: white;
    }
  }


.plan-radiobutton {
	padding: 16px;
	text-align: initial;
	border: solid 1px #eff3f5;
	background-color: #fff;
	width: 32.3%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	cursor: pointer;
}
.plan-radiobutton:last-of-type() {
	margin-right: 0
}
.plan-radiobutton:last-child {
	margin-right: 0px;
}
.plan-radiobutton h3 {
	font-size: 18px;
	font-weight: bold;
	line-height: 1;
	text-align: initial;
	color: #6B47F5;
	text-transform: uppercase;
}
.plan-radiobutton p {
	font-size: 14px;
	font-weight: normal;
	color: #494948;
	width: 100%;
}
.plan-radiobutton h4 {
	font-size: 17px;
	font-weight: bold;
	line-height: 1.04;
	color: #6B47F5;
}
.plan-type {
	padding: 16px;
	background-color: #eef2f5;
	text-align: initial;
	margin: 20px 0;
}
.custom-card {
	max-width: 100%;
	margin-bottom: 20px;
}
.custom-card label {
	font-size: 13px;
	font-weight: bold;
	color: #4c565c;
	display: block;
	margin-bottom: 10px;
}
.custom-card .p-inputtext {
	margin: 0;
	width: 100%;
	border-radius: 0;
}
.custom-card .p-dropdown {
	width: 100%;
	border-radius: 0;
}
.repair label {
	font-size: 13px;
	font-weight: bold;
	color: #4c565c;
	display: block;
	margin-bottom: 10px;
}
.repair .p-buttonset .p-button {
	width: 48%;
	margin: 0 1%;
	color: #6B47F5;
	font-size: 16px;
	font-weight: bold;
	border-radius: 0;
	padding: 9px 12px;
}
.repair .p-buttonset .p-button:hover {
	color: #fff;
	border: solid 1px #6B47F5;
	background-color: #6B47F5;
}
.p-selectbutton .p-button.p-highlight {
	color: #fff;
	border: solid 1px #6B47F5;
	background-color: #6B47F5;
}
.manufacturing {
	margin-bottom: 20px;
}
.manufacturing .p-dropdown {
	width: 100%;
	padding: 0 0.3px 0 17px;
	border: solid 1px #b5bbc3;
	background-color: #fff;
	border-radius: 0;
}
.manufacturing label {
	font-size: 13px;
	font-weight: bold;
	color: #4c565c;
	display: block;
	margin-bottom: 10px;
}
.repair .p-buttonset .p-button:focus {
	box-shadow: none;
}
.p-radiobutton .p-radiobutton-box.p-highlight {
	border-color: #6B47F5;
	background: #fff;
	box-shadow: none;
}
.p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
	border-color: #6B47F5;
	background: #fff;
	color: #ffffff;
}
.p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
	background-color: #6B47F5;
}
.p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
	border-color: #6B47F5;
}
.p-radiobutton-focused {
	outline: none;
	border: none;
}
.plan-details {
	display: flex;
	padding: 0;
}
.downarrow {
	display: none;
	color: #6B47F5;
}
.p-inputswitch {
	width: 3em;
}
.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
	background: #34c759;
}
.p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider {
	background: #34c759;
}
@media only screen and (max-width: 576px) {
	background-color: #f4f4f4;
	.container {
		width: 90%;
	}
	
	.insurance h3 {
		font-size: 17px;
		color: #6B47F5;
		width: 100%;
		text-align: initial;
		margin-bottom: 20px;
	}
	
	.plan-radiobutton {
		margin-right: 5px;
		width: 33%;
		padding: 8px 10px;
		border-radius: 10px;
		border: solid 1px #edf2f5;
		background-color: #fff;
		text-align: center;
	}
	
	.plan-radiobutton:last-child {
		margin-right: 0px;
	}
	
	.plan-radiobutton p {
		font-size: 9px;
	}
	
	.plan-radiobutton h3 {
		font-size: 13px;
		font-weight: 800;
		text-align: center;
		color: #6B47F5;
		margin-bottom: 10px;
	}
	
	.plan-details {
		padding: 0;
	}
	
	.plan-type {
		border-radius: 10px;
	}
	
	.p-component {
		width: 100%;
		color: #6B47F5;
	}
	
	.p-inputtext {
		color: #6B47F5;
	}
	
	.plan-check .p-radiobutton .p-radiobutton-box {
		margin: auto;
	}
	
	.downarrow {
		display: block;
	}
	
	.p-inputswitch {
		width: 3em;
	}
	
	.p-inputtext {
		border-radius: 5px;
	}
}
.ar {
	.plan-radiobutton {
		text-align: right;
		margin-right: 0;
	}
	
	.plan-radiobutton:last-of-type() {
		margin: 0;
	}
}
.homeInsureanceImage {
	max-width: 100%;
	height: auto;
  }

// .plan-radiobutton {margin: 0 15px;}
// .plan-radiobutton:last-of-type(){margin: 0;}
// .plan-radiobutton:first-of-type(){margin: 0;}


.motor-drive {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    margin-top: 20px;
  }

  .motor-drive-2 {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 12px;
  }

  .motor-drive-2 input[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    background-color: #D9DCE1;
    margin: 0;
    color: white;
    width: 20px;
    min-width: 20px;
    height: 20px;
    border: none;
    border-radius: 0.15em;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
  }

  .motor-drive-2 input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: #FFFFFF;
    color: #6B47F5;
  }

  .motor-drive-2 input:checked {
    background-color: #6B47F5 !important;
  }

  .motor-drive-2 input[type="checkbox"]:checked::before {
    transform: scale(1);
  }

  .motor-drive-2 input[type="checkbox"]:disabled {
    --form-control-color: var(--form-control-disabled);
  
    color: var(--form-control-disabled);
    cursor: not-allowed;
  }

  .motor-drive-title {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 160%;
    display: flex;
    align-items: center;
    color: #455560;
    span, a {
      color: #6B47F5 !important;
      text-decoration: none;
    }
  }

`;

export default InsuranceWraper;